/**
 * Main application component
 *
 * features:
 * - router provider for react-router
 * - router for app routes
 */

import { router } from '@/app/routes/AppRoutes';
import { renderPageAgentChat } from '@/app/routes/PageAgentChat';
import { RouterProvider } from 'react-router';
import { PageAgentRendererProvider } from '@/entities/agent';
import { SupportRequestSheet } from '@/features/support-request';
import { setSupportSheetOpen, useIsSupportSheetOpen } from '@/widgets/app-shell';

function App() {
  const isSupportSheetOpen = useIsSupportSheetOpen();

  return (
    <PageAgentRendererProvider render={renderPageAgentChat}>
      <RouterProvider router={router} />
      <SupportRequestSheet open={isSupportSheetOpen} onOpenChange={setSupportSheetOpen} />
    </PageAgentRendererProvider>
  );
}

export default App;
